import type { ComponentType } from "react";
import DebitNoteToRejectionPdfComponent from "./DebitNoteToRejectionPdf.jsx";

const DebitNoteToRejectionPdf = DebitNoteToRejectionPdfComponent as ComponentType<any>;
export default DebitNoteToRejectionPdf;
